import { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { createPortal } from "react-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RedoIcon from "@mui/icons-material/Redo";
import { useNavigate, useParams } from "react-router-dom";
import url from "../../../../config/axios";
import moment from "moment";
import BAckArrow from "../../../../components/backArrow";
import "../viewApplication/viewapplication.css";
import { useSelector } from "react-redux";
import ShareModel from "../../../../components/Sharemodel";
import ShareOption from "../../../../components/Shareoption";
import "./viewbuyapplication.css";

const ViewbuyApplication = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const { id } = useParams();
  const [employeedata, setEmployeedata] = useState(null);
  const [showshare, setShowshare] = useState(0);
  const [show, setShow] = useState(0);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await url.get(`/employee/id/?id=${id}`);
        setEmployeedata(response?.data?.data?.Employee);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };
    fetchEmployeeData();
  }, [id]);

  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const handleClosemodal = () => {
    setShow(0);
  };

  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };

  const renderApplicationActions = (className) => (
    <div className={className}>
      <button
        className="m-0 btn btn-primary pt-1 pb-1"
        onClick={() => {
          const candidateUserId =
            employeedata?.userid?._id || employeedata?.userid || "";
          navigate(`/view-candidate-cv/${candidateUserId}`);
        }}
        disabled={!employeedata?.userid}
      >
        <VisibilityIcon className="iconWhite me-1" fontSize="small" />
        View CV
      </button>
      <button
        className="m-0 btn btn-primary pt-1 pb-1"
        onClick={() => setShow(1)}
      >
        Share&nbsp;<RedoIcon fontSize="small" />
      </button>
    </div>
  );

  return (
    <>
      <Container fluid className="view-buy-application-page">
      <Row className="view-buy-application-row">
        <ShareOption
          showshare={showshare}
          handleCloseshare={handleCloseshare}
        />
        <ShareModel
          handleClosemodal={handleClosemodal}
          show={show}
          handleShowshare={handleShowshare}
          shareurl={`${window.location.origin}/view-buy-application/${id}`}
          shopTitle={employeedata?.jobtitle || "Job Application"}
          shopDesc={employeedata?.jobdescription || ""}
          disableShopAutoDetect
        />
        <div className="view-buy-application-layout">
          <Col xs={12} sm={10} md={8} lg={6} xl={5} className="Form-Shadow view-buy-application-card mx-auto">
            <div className="arrowback pe-3 pt-2 pb-1">
              <BAckArrow
                back="/create-job-app"
                black="black"
                mystyle="ps-3 p-1"
              />
            </div>
            <div className="ps-3 pe-2">
              <div className="ps-3">
                <h4 className="fs-4 mb-1">Application</h4>
              </div>
              <div className="ps-3">
                <h6>Job Type</h6>
                <p className="font_13">{employeedata?.jobtype || "N/A"}</p>
              </div>
              <div className="ps-3">
                <h6 className="mb-1 jobviewhead">Salary</h6>
                <p className="ViewlabelText mb-1">{employeedata?.salarywant || "N/A"}</p>
              </div>
              <div className="ps-3">
                <h6 className="mb-1 pt-1 jobviewhead">Job</h6>
                <p className="ViewlabelText mb-1">{employeedata?.jobtitle || "N/A"}</p>
              </div>
              <div className="ps-3">
                <h6 className="mb-1 pt-1 jobviewhead">Country, State, City</h6>
                <p className="ViewlabelText mb-1">
                  {employeedata?.country
                    ? `${employeedata.country}, ${employeedata.state}, ${employeedata.city}`
                    : "N/A"}
                </p>
              </div>
              <div className="ps-3">
                <h6 className="mb-1 pt-1 jobviewhead">Job Experience</h6>
                <p className="ViewlabelText mb-1">{employeedata?.jobexperience || "N/A"}</p>
              </div>
              <div className="ps-3">
                <h6 className="mb-1 pt-1 jobviewhead">Contact Number</h6>
                <p className="ViewlabelText mb-1">{name?.phonenumber || "N/A"}</p>
              </div>
              <div className="ps-3">
                <h6 className="mb-1 pt-1 jobviewhead">Remaining Time</h6>
                <p className="ViewlabelText mb-1">
                  {employeedata?.duration
                    ? moment(employeedata.duration).format("DD-MMMM-YYYY")
                    : "N/A"}
                </p>
              </div>
              <div className="ps-3">
                <h6 className="mb-3 pt-1 jobviewhead">Description</h6>
                <p className="ViewlabelText">{employeedata?.jobdescription || "N/A"}</p>
              </div>
              <div>
                {renderApplicationActions(
                  "view-buy-application-actions-desktop pt-3 pb-3"
                )}
              </div>
            </div>
          </Col>
        </div>
      </Row>
      </Container>
      {typeof document !== "undefined" &&
        createPortal(
          renderApplicationActions("view-buy-application-actions-mobile"),
          document.body
        )}
    </>
  );
};

export default ViewbuyApplication;